var _defs, _g, _g2, _rect, _rect2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a{stroke:#606060;stroke-miterlimit:10;}.b{fill:#606060;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 12,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1,
    height: 3,
    transform: "translate(5 1)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1,
    height: 3,
    transform: "translate(10 1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(0 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 2,
    rx: 1,
    transform: "translate(4 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.389d62a8491176a069e5e5680c860f3c.svg";
export { ForwardRef as ReactComponent };